<template>
  <section class="skeleton content">
    <div class="skeleton__box content__left">
      <p class="skeleton__content skeleton__animate"></p>
      <p class="skeleton__content skeleton__animate"></p>
      <p class="skeleton__content skeleton__animate"></p>
    </div>
    <div class="skeleton__box content__right">
      <div class="skeleton__box content__level">
        <p class="skeleton__content skeleton__animate"></p>
        <figure class="skeleton__btn skeleton__animate content__btn"></figure>
      </div>
      <div class="skeleton__box content__level">
        <p class="skeleton__content skeleton__animate"></p>
        <figure class="skeleton__btn skeleton__animate content__btn"></figure>
      </div>
      <div class="skeleton__box content__level">
        <p class="skeleton__content skeleton__animate"></p>
        <figure class="skeleton__btn skeleton__animate content__btn"></figure>
      </div>
      <div class="skeleton__box content__level">
        <p class="skeleton__content skeleton__animate"></p>
        <figure class="skeleton__btn skeleton__animate content__btn"></figure>
      </div>
      <div class="skeleton__box content__level">
        <p class="skeleton__content skeleton__animate"></p>
        <figure class="skeleton__btn skeleton__animate content__btn"></figure>
      </div>
      <div class="skeleton__box content__level">
        <p class="skeleton__content skeleton__animate"></p>
        <figure class="skeleton__btn skeleton__animate content__btn"></figure>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CourseContentSkel',
}
</script>

<style lang="scss" scoped>
.content {
  margin: 50px 0 0 0;
  padding: 0 50px;
  min-height: 50vh;
  display: flex;
  flex-wrap: wrap;
  @include tablet {
    flex-wrap: nowrap;
  }
  &__left {
    width: 100%;
    height: 250px;
    background: var(--light-gray);
    padding: 25px;
    @include tablet {
      width: 25%;
      margin: 0 25px;
      padding: 50px;
    }
  }
  &__right {
    width: 100%;
    height: 75px;
    background: var(--light-gray);
    @include tablet {
      width: 75%;
      margin: 0 25px;
    }
  }
  &__level {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 50px;
  }
  &__btn {
    margin: 0 0 0 50px;
    width: 150px;
  }
}
</style>
